import { type ApiError, api } from "@/lib/api";
import type { Group, GroupMember } from "@/types";

export async function listOrgGroups(
  orgId: string,
): Promise<{ data: Group[]; error: null } | { data: null; error: ApiError }> {
  return api.get<Group[]>(`/organizations/${orgId}/groups`);
}

export async function createGroup(
  orgId: string,
  body: {
    name: string;
    slug: string;
    type?: string;
    parentId?: string;
  },
): Promise<{ data: { id: string }; error: null } | { data: null; error: ApiError }> {
  return api.post(`/organizations/${orgId}/groups`, body);
}

export async function getGroup(
  groupId: string,
): Promise<{ data: Group; error: null } | { data: null; error: ApiError }> {
  return api.get<Group>(`/groups/${groupId}`);
}

export async function updateGroup(
  groupId: string,
  body: {
    name?: string;
    slug?: string;
    type?: string;
    parentId?: string | null;
  },
): Promise<{ data: { success: boolean }; error: null } | { data: null; error: ApiError }> {
  return api.patch(`/groups/${groupId}`, body);
}

export async function deleteGroup(
  groupId: string,
): Promise<{ data: { success: boolean }; error: null } | { data: null; error: ApiError }> {
  return api.delete(`/groups/${groupId}`);
}

export async function listGroupMembers(
  groupId: string,
): Promise<{ data: GroupMember[]; error: null } | { data: null; error: ApiError }> {
  return api.get<GroupMember[]>(`/groups/${groupId}/members`);
}

export async function addGroupMember(
  groupId: string,
  targetUserId: string,
): Promise<{ data: { success: boolean }; error: null } | { data: null; error: ApiError }> {
  return api.post(`/groups/${groupId}/members`, { targetUserId });
}

export async function updateGroupMemberRole(
  groupId: string,
  targetUserId: string,
  role: string,
): Promise<{ data: { success: boolean }; error: null } | { data: null; error: ApiError }> {
  return api.patch(`/groups/${groupId}/members/${targetUserId}`, { role });
}

export async function removeGroupMember(
  groupId: string,
  targetUserId: string,
): Promise<{ data: { success: boolean }; error: null } | { data: null; error: ApiError }> {
  return api.delete(`/groups/${groupId}/members/${targetUserId}`);
}

export async function leaveGroup(
  groupId: string,
): Promise<{ data: { success: boolean }; error: null } | { data: null; error: ApiError }> {
  return api.post(`/groups/${groupId}/leave`);
}
